export default "__VITE_ASSET__DJnq1iP9__"